<template>
    <KButton
        v-if="label && href"
        :as="isExternal ? 'a' : nuxtLink"
        :to="isExternal ? undefined : href"
        :href="isExternal ? href : undefined"
        :target="isExternal ? link.target || undefined : undefined"
        :rel="isExternal && link.target === '_blank' ? 'noopener noreferrer' : undefined"
        variant="secondary"
        @click="track"
    >
        {{ label }}
        <template #icon-end>
            <Icon
                name="tabler:arrow-right"
                aria-hidden="true"
            />
        </template>
    </KButton>
</template>

<script setup>
import { KButton } from '@vemedia/karibu'
import { isExternalStoryblokLink, storyblokLinkHref } from '~~/shared/storyblok-link'

const props = defineProps({
    label: {
        type: String,
        default: '',
    },
    link: {
        type: Object,
        default: () => ({}),
    },
    placement: {
        type: String,
        required: true,
    },
})

const nuxtLink = resolveComponent('NuxtLink')
const { capture } = useTracking()
const href = computed(() => storyblokLinkHref(props.link))
const isExternal = computed(() => isExternalStoryblokLink(props.link))

function track() {
    capture('section_header_action_clicked', {
        placement: props.placement,
        label: props.label,
        url: href.value,
    })
}
</script>
